export default __webpack_public_path__ + "static/media/Download~bhgbCOxP.afe50ccf.svg";